require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./accordion"), require("./checkboxgroup"), require("./container"), require("./label"), require("./list"), require("./radiogroup"), require("./separator"), require("./toggleswitchgroup"), require("./utils"), require("./vspacer"));
	else if(typeof define === 'function' && define.amd)
		define(["./accordion", "./checkboxgroup", "./container", "./label", "./list", "./radiogroup", "./separator", "./toggleswitchgroup", "./utils", "./vspacer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./accordion"), require("./checkboxgroup"), require("./container"), require("./label"), require("./list"), require("./radiogroup"), require("./separator"), require("./toggleswitchgroup"), require("./utils"), require("./vspacer")) : factory(root["./accordion"], root["./checkboxgroup"], root["./container"], root["./label"], root["./list"], root["./radiogroup"], root["./separator"], root["./toggleswitchgroup"], root["./utils"], root["./vspacer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__37594__, __WEBPACK_EXTERNAL_MODULE__8634__, __WEBPACK_EXTERNAL_MODULE__32299__, __WEBPACK_EXTERNAL_MODULE__37394__, __WEBPACK_EXTERNAL_MODULE__70309__, __WEBPACK_EXTERNAL_MODULE__46061__, __WEBPACK_EXTERNAL_MODULE__16717__, __WEBPACK_EXTERNAL_MODULE__43132__, __WEBPACK_EXTERNAL_MODULE__78815__, __WEBPACK_EXTERNAL_MODULE__57176__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[8860],{

/***/ 60131:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _list = _interopRequireDefault(__webpack_require__(70309));
var _utils = __webpack_require__(78815);
var _radiogroup = _interopRequireDefault(__webpack_require__(46061));
var _checkboxgroup = _interopRequireDefault(__webpack_require__(8634));
var _toggleswitchgroup = __webpack_require__(43132);
var _label = _interopRequireDefault(__webpack_require__(37394));
var _accordion = _interopRequireWildcard(__webpack_require__(37594));
var _vspacer = _interopRequireDefault(__webpack_require__(57176));
var _separator = _interopRequireDefault(__webpack_require__(16717));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _Menu = _interopRequireDefault(__webpack_require__(76394));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const MenuClassName = _Menu.default.menuClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;

/* eslint no-underscore-dangle: 'off' */

function isPropsValid(props) {
  if (!props.name) {
    console.error('A name property must be specified for each Menu Section.'); // eslint-disable-line no-console
  }
}

function getGroupedSection(sectionContent, label, accordion, type) {
  const {
    list,
    radio,
    checkbox,
    toggleswitch
  } = type;
  return /*#__PURE__*/_react.default.createElement("div", null, accordion ? /*#__PURE__*/_react.default.createElement("div", null, sectionContent) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _utils.classnames)(`${MenuClassName}__grouped-section`, {
      list,
      radio,
      checkbox,
      toggleswitch
    })
  }, label && /*#__PURE__*/_react.default.createElement(_label.default, {
    type: "caption",
    label: label
  }), sectionContent));
}
function isSelected(itemProps, index) {
  const {
    selected,
    name,
    content
  } = itemProps;
  return selected[name] === content[index].value;
}
function onChangeList(itemProps, event) {
  const {
    content,
    onChange,
    selected,
    name
  } = itemProps;
  const index = _utils.listHelper.singleSelect(event, content, selected[name]);
  const item = content[index];
  onChange && onChange(name, item.value, event.disabled);
}
function onChangeCheckboxOrToggle(content, label, name, checkboxSelected, onChange) {
  const selectedIndex = content.map(item => item.label).indexOf(label);
  const valueToChange = content[selectedIndex].value;
  checkboxSelected[valueToChange] = !checkboxSelected[valueToChange];
  onChange && onChange(name, checkboxSelected);
}
class Menu extends _react.Component {
  static Separator(props) {
    return /*#__PURE__*/_react.default.createElement(_separator.default, (0, _extends2.default)({
      "data-tid": "ba-common-menu__separator"
    }, props));
  }
  static Spacer(props) {
    return /*#__PURE__*/_react.default.createElement(_vspacer.default, (0, _extends2.default)({
      "data-tid": "ba-common-menu__spacer"
    }, props));
  }
  static Accordion(props) {
    const {
      onChange,
      selected,
      children,
      ...passThrough
    } = props;
    return /*#__PURE__*/_react.default.createElement(_accordion.default, (0, _extends2.default)({
      "data-tid": "ba-common-menu__accordion"
    }, passThrough, {
      className: `${MenuClassName}__grouped-section`
    }), _react.Children.map(children, child => /*#__PURE__*/_react.default.createElement(_accordion.AccordionItem, {
      "data-tid": `ba-common-menu__accordion-item-${child.props.name}`,
      id: `ba-accordion-item-1-${child.props.name}`,
      itemName: child.props.label,
      icon: "left"
    }, (0, _react.cloneElement)(child, {
      onChange,
      selected,
      accordion: true
    }))));
  }
  static List(props) {
    isPropsValid(props);
    const {
      content,
      accordion,
      label,
      onChange,
      name,
      selected,
      clickSelection,
      ...passThrough
    } = props;
    const listProps = {
      'data-tid': 'ba-common-menu__list',
      ...passThrough,
      options: content,
      isSelected: index => isSelected({
        content,
        onChange,
        selected,
        name
      }, index),
      onSelectionChange: event => onChangeList(props, event),
      length: content.length,
      initialIndex: 0,
      selectionMode: 'single',
      tabIndex: 0,
      clickSelection
    };
    const sectionContent = /*#__PURE__*/_react.default.createElement(_list.default, listProps);
    return getGroupedSection(sectionContent, label, accordion, {
      list: true
    });
  }
  static Radio(props) {
    isPropsValid(props);
    const {
      content,
      accordion,
      label,
      onChange,
      selected,
      name,
      ...passThrough
    } = props;
    const radioProps = {
      'data-tid': 'ba-common-menu__radios',
      ...passThrough,
      options: content,
      direction: 'vertical',
      checked: selected[name],
      onChange: value => onChange(name, value)
    };
    const sectionContent = /*#__PURE__*/_react.default.createElement(_radiogroup.default, radioProps);
    return getGroupedSection(sectionContent, label, accordion, {
      radio: true
    });
  }
  static Checkbox(props) {
    isPropsValid(props);
    const {
      content,
      accordion,
      label,
      onChange,
      selected,
      name,
      ...passThrough
    } = props;
    const checkboxSelected = selected[name] ? {
      ...selected[name]
    } : {};

    // Conversion for object value being set to true to label being set to true for checkboxgroup
    const parsedCheckboxSelected = {};
    for (let i = 0; i < content.length; i++) {
      if (checkboxSelected[content[i].value]) parsedCheckboxSelected[content[i].label] = true;
    }
    const checkboxProps = {
      'data-tid': 'ba-common-menu__checkboxes',
      ...passThrough,
      options: content,
      direction: 'vertical',
      selected: parsedCheckboxSelected,
      onChange: value => onChangeCheckboxOrToggle(content, value, name, checkboxSelected, onChange)
    };
    const sectionContent = /*#__PURE__*/_react.default.createElement(_checkboxgroup.default, checkboxProps);
    return getGroupedSection(sectionContent, label, accordion, {
      checkbox: true
    });
  }
  static ToggleSwitch(props) {
    isPropsValid(props);
    const {
      content,
      accordion,
      label,
      onChange,
      selected,
      name,
      ...passThrough
    } = props;
    const ToggleSwitchSelected = selected[name] ? {
      ...selected[name]
    } : {};
    const parsedToggleSwitchSelected = {};
    for (let i = 0; i < content.length; i++) {
      if (ToggleSwitchSelected[content[i].value]) {
        parsedToggleSwitchSelected[content[i].label] = true;
      }
    }
    const toggleswitchprops = {
      'data-tid': 'ba-common-menu__toggleswitches',
      ...passThrough,
      options: content,
      direction: 'vertical',
      selected: parsedToggleSwitchSelected,
      small: true,
      onChange: value => onChangeCheckboxOrToggle(content, value, name, ToggleSwitchSelected, onChange)
    };
    const sectionContent = /*#__PURE__*/_react.default.createElement(_toggleswitchgroup.ToggleSwitchGroup, toggleswitchprops);
    return getGroupedSection(sectionContent, label, accordion, {
      toggleswitch: true
    });
  }
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_containerRef", node => {
      this._container = node;
    });
    this.state = {
      top: 0,
      left: 0
    };
  }
  componentDidMount() {
    if (this._container) this._getPosition();
  }
  componentDidUpdate(prevProps) {
    // If now there is positioning and previously there wasn't
    if (this.props.position && !prevProps.position) {
      this._getPosition();
      // Or if there is positioning, and previously there was, check if that positioning has changed and if so update the position
    } else if (this.props.position) {
      if (prevProps.position.x !== this.props.position.x || prevProps.position.y !== this.props.position.y || prevProps.width !== this.props.width) {
        this._getPosition();
      }
    }
  }

  // This is being done this way to mimic the behaviour of context menus in Glass
  _getPosition() {
    const {
      position
    } = this.props;
    const containerRect = this._container._node.getBoundingClientRect();
    const width = containerRect.width + 3;
    const height = containerRect.height + 3;
    let left;
    if (window.innerWidth - position.x < width) {
      left = window.innerWidth - width;
    } else {
      left = position.x;
    }
    let top;
    if (window.innerHeight - position.y < height) {
      top = window.innerHeight - height;
    } else {
      top = position.y;
    }
    this.setState({
      top,
      left
    });
  }
  render() {
    const {
      children,
      onChange,
      selected,
      position,
      width,
      height,
      className,
      style,
      ...others
    } = this.props;
    const {
      top,
      left
    } = this.state;
    const classNames = (0, _utils.classnames)(MenuClassName);
    const contentWidth = position ? '100%' : width;
    const contentHeight = position ? '100%' : height;
    const content = /*#__PURE__*/_react.default.createElement("div", {
      className: `${classNames} ${className}`,
      style: {
        width: contentWidth,
        height: contentHeight
      }
    }, _react.Children.map(children, child => child && (0, _react.cloneElement)(child, {
      onChange,
      selected
    })));
    const styles = {
      position: 'fixed',
      top: `${top}px`,
      left: `${left}px`,
      ...style
    };
    return position ? /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, Menu), {
      className: `${MenuClassName}__container ${className}`,
      width: width,
      gutter: [0, 0],
      height: height,
      style: styles,
      ref: this._containerRef
    }), content) : content;
  }
}
exports["default"] = Menu;
(0, _defineProperty2.default)(Menu, "propTypes", {
  /** Sub-components of Menu to display (i.e. Menu.List, Menu.Radio, etc.) */
  children: _propTypes.default.node,
  /** Function that is called when a value in the Menu changes (name and value are arguments) */
  onChange: _propTypes.default.func,
  /** Object that defines which items from each sub-component are selected */
  selected: _propTypes.default.object,
  /** Defines the position of where the menu should be fixed on the screen */
  position: _propTypes.default.shape({
    x: _propTypes.default.number.isRequired,
    y: _propTypes.default.number.isRequired
  }),
  /** The width of the menu */
  width: _propTypes.default.string,
  /** The height of the menu */
  height: _propTypes.default.string,
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Custom CSS styling */
  style: _propTypes.default.object
});
(0, _defineProperty2.default)(Menu, "defaultProps", {
  selected: {},
  className: '',
  style: {}
});

/***/ }),

/***/ 1326:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Menu = _interopRequireDefault(__webpack_require__(60131));
exports["default"] = _Menu.default;
exports.Menu = _Menu.default;

/***/ }),

/***/ 18445:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".is-contextMenu{background-color:#fff}.ba-common-menu .ba-radioGroup,.ba-common-menu .ba-checkboxGroup,.ba-common-menu .ba-toggleswitchGroup,.ba-common-menu .ba-common-list{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-menu .ba-common-label{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-menu__grouped-section{padding:0;width:100%;min-width:104px}.ba-common-menu__grouped-section.is-radio,.ba-common-menu__grouped-section.is-checkbox,.ba-common-menu__grouped-section.is-toggleswitch{padding:1rem}.ba-common-menu__grouped-section.is-list .ba-common-label{padding-top:1rem}.ba-common-menu .ba-common-menu__icon{display:flex}.ba-common-menu .ba-common-menu__item{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;height:32px;display:flex;align-items:center;cursor:pointer;border-left-width:4px}.ba-common-menu .ba-common-menu__item .ba-common-toolTip{width:100%}.ba-common-menu .ba-common-menu__item--text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ba-common-menu .ba-common-menu__item.is-disabled{cursor:not-allowed}.ba-common-menu .ba-common-menu__item.is-disabled--text .cursor{cursor:not-allowed}.ba-common-menu:not(.is-contextMenu){background-color:#fff}.ba-common-menu__container{min-width:200px;box-shadow:0 2px 6px 0 rgba(0,0,0,.3);border:#a8c0f3;z-index:top-front-layer}[dir=ltr] .ba-common-menu__grouped-section.is-list .ba-common-label,.ba-common-menu__grouped-section.is-list .ba-common-label{padding-left:1rem}[dir=ltr] .ba-common-menu .ba-common-menu__icon,.ba-common-menu .ba-common-menu__icon{margin-right:8px}[dir=rtl] .ba-common-menu__grouped-section.is-list .ba-common-label{padding-left:unset;padding-right:1rem}[dir=rtl] .ba-common-menu .ba-common-menu__icon{margin-right:unset;margin-left:8px}", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-menu\""
};

/***/ }),

/***/ 76394:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18445);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Menu_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 37594:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37594__;

/***/ }),

/***/ 8634:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__8634__;

/***/ }),

/***/ 32299:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32299__;

/***/ }),

/***/ 37394:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37394__;

/***/ }),

/***/ 70309:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__70309__;

/***/ }),

/***/ 46061:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__46061__;

/***/ }),

/***/ 16717:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__16717__;

/***/ }),

/***/ 43132:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__43132__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ }),

/***/ 57176:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__57176__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(1326));
/******/ return __webpack_exports__;
/******/ }
]);
});